<template>
    <v-card v-observe-visibility="visibilityChanged">
        <v-toolbar light color="white">
            <v-btn icon @click.native="closeNewUsersDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedUser.id === 0">Add New User</v-toolbar-title>
            <v-toolbar-title v-else>Edit User - {{selectedUser.name}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-layout row v-if="getNetworkError">
            <v-flex xs12>
                <app-alert @dismissed="onDismissedError" :text="getNetworkError.message"></app-alert>
            </v-flex>
        </v-layout>
        <v-tabs
                color="secondary"
                dark
                slider-color="primary"
        >
            <v-tab>User</v-tab>
            <v-tab-item>
                <v-progress-linear class="top-loading" :active="loading"
                                   :indeterminate="true"></v-progress-linear>
                <v-card-text>
                    <v-form ref="form" v-model="formValidation" lazy-validation>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 md5 ma-3>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            <v-card dark color="secondary">
                                                <v-card-title>User Info</v-card-title>
                                            </v-card>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model="selectedUser.name"
                                                    label="Name">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model="selectedUser.email"
                                                    label="Username/Login"
                                                    type="email">
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field
                                                    :append-icon="showPW ? 'visibility_off' : 'visibility'"
                                                    :type="showPW ? 'text' : 'password'"
                                                    v-model="selectedUser.password"
                                                    @click:append="showPW = !showPW"
                                                    label="Password"

                                            >
                                            </v-text-field>
                                        </v-flex>


                                        <v-flex xs12>
                                            <v-text-field
                                                    :append-icon="showConfirmPW ? 'visibility_off' : 'visibility'"
                                                    :type="showConfirmPW ? 'text' : 'password'"
                                                    v-model="confirmPW"
                                                    @click:append="showConfirmPW = !showConfirmPW"
                                                    label="Confirm Password"
                                                    :rules=passwordConfirmationRules
                                            >
                                            </v-text-field>
                                        </v-flex>

                                        <v-select xs12
                                                  :items=userRoles
                                                  label="Role"
                                                  item-value="id"
                                                  item-text="name"
                                                  v-model="selectedUser.users_roles_id"
                                                  required
                                        ></v-select>

                                    </v-layout>


                                </v-flex>


                                <v-flex xs12 md5 ma-3>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            <v-card dark color="secondary">
                                                <v-card-title>Account Info</v-card-title>
                                            </v-card>
                                        </v-flex>


                                        <v-select xs12
                                                  :items=salutions
                                                  label="Salution"
                                                  v-model="selectedUser.accounts[0].salution"
                                                  required
                                        ></v-select>

                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model="selectedUser.accounts[0].firstname"
                                                    label="First name">
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model="selectedUser.accounts[0].lastname"
                                                    label="Last name">
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model="selectedUser.accounts[0].email"
                                                    label="E-Mail">
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs8>
                                            <v-text-field
                                                    v-model="selectedUser.accounts[0].street"
                                                    label="Street">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-text-field
                                                    v-model="selectedUser.accounts[0].hnumber"
                                                    label="No.">
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs7>
                                            <v-text-field
                                                    v-model="selectedUser.accounts[0].city"
                                                    label="City">
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs5>
                                            <v-text-field
                                                    v-model="selectedUser.accounts[0].zipcode"
                                                    label="Zipcode">
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-autocomplete
                                                    :items="countries"
                                                    label="Country"
                                                    v-model="selectedUser.accounts[0].country"
                                                    required
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-menu
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    :return-value.sync="selectDate"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-x
                                                    full-width
                                                    min-width="290px"
                                            >
                                                <v-text-field
                                                        slot="activator"
                                                        v-model="selectedUser.accounts[0].birthday"
                                                        label="Birthday"
                                                        prepend-icon="event"
                                                        readonly
                                                        required
                                                ></v-text-field>
                                                <v-date-picker pb-5 mb-5 v-model="selectedUser.accounts[0].birthday"
                                                               :landscape="true"
                                                ></v-date-picker>

                                            </v-menu>
                                        </v-flex>

                                    </v-layout>

                                    <v-layout mt-5 row justify-end>
                                        <v-btn :disabled="userFormEdited" mt-5 color="secondary"
                                               @click.native="saveUser(0)">
                                            Save
                                            <v-icon class="white--text" right>save</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </v-flex>

                            </v-layout>

                        </v-container>
                    </v-form>
                </v-card-text>
            </v-tab-item>

        </v-tabs>

    </v-card>
</template>


<script>
    import {
        Settings,
        UserSettings
    } from '../../store/namespace-helper'

    export default {
      name: 'add-new-user',
      data () {
        return {
          salutions: [
            'Mr.',
            'Mrs.'
          ],
          showPW: false,
          showConfirmPW: false,
          confirmPW: '',
          isVisible: false,
          onDismissed: false,
          userUpdated: 0,
          selectDate: null,
          formValidation: false,
                /*          passwordConfirmationRules: [
                            (v) => !!v || 'Confirmation Password is required',
                            (v) => v === this.selectedUser.password || 'Password must match'
                          ], */
          passwordConfirmationRules: [
            (v) => (v === this.selectedUser.password || this.selectedUser.password === undefined) || 'Password must match'
          ],
          countries: this.$store.getters.countries
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.$store.dispatch(UserSettings.actions.loadAllUserRoles)
              this.userUpdated = 0
            } else {
              this.userUpdated = 0
            }
          }
        },
        closeNewUsersDialog () {
          this.confirmPW = ''
          this.selectedUser.password = ''
          this.$store.dispatch(UserSettings.actions.setSelectedUser, null)
          this.$store.dispatch(UserSettings.actions.openCloseNewUserDialog)
        },
        saveUser (index) {
          if (!this.$refs.form.validate()) {
            return
          }
          this.$store.dispatch(UserSettings.actions.saveUser, this.selectedUser)
          this.userUpdated = 0
        },
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
          setTimeout(function () {
            location.reload()
          }, 850)
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        }

      },
      computed: {
        dialog () {
          return this.$store.getters[UserSettings.getters.getOpenNewUserDialogState]
        },
        selectedUser () {
          console.log('selected user function: ' + JSON.stringify(this.$store.getters[UserSettings.getters.getSelectedUser]))
          return this.$store.getters[UserSettings.getters.getSelectedUser]
        },
        userRoles () {
          return this.$store.getters[UserSettings.getters.getAllUserRoles]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        userFormEdited () {
          return this.userUpdated < 1
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        }

      },
      watch: {
        selectedUser: {
          handler (val) {
            console.log('selectedUser data changed: ' + JSON.stringify(val))
            this.userUpdated++
            console.log('userUpdated:' + this.userUpdated)
          },
          deep: true
        }
      }
    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .top-loading {
        margin-top: 0px;
    }


</style>


// WEBPACK FOOTER //
// src/components/Shared/AddUser.vue